import { useCallback } from 'preact/hooks';

export type DownToggleDetail = {
  value: boolean;
};

export type DownToggleOptions = {
  isDisabled?: boolean;
  onToggle?: (details: DownToggleDetail) => void;
  isOpen?: boolean;
};

export type DownToggleReturnType = {
  triggerProps: Record<string, any>;
};

/**
 * Toggle a state when down arrow is pressed to control a popup.
 * This can be used to control the visibility of a dropdown such as a color picker or menu.
 *
 * @returns
 */
export function useDownToggle({
  isDisabled,
  isOpen,
  onToggle
}: DownToggleOptions): DownToggleReturnType {
  // DOWN ARROW invokes dropdown
  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key == 'ArrowDown') {
        !isDisabled && onToggle?.({ value: !isOpen });
        event.preventDefault();
      }
    },
    [isDisabled, isOpen, onToggle]
  );

  const triggerProps = isDisabled
    ? {}
    : {
        onKeyDown,
        'aria-haspopup': 'true',
        'aria-expanded': isOpen
      };

  return {
    triggerProps: triggerProps
  };
}
